import { render } from "./AuthBanner.vue?vue&type=template&id=2faab3d8&scoped=true&ts=true"
import script from "./AuthBanner.vue?vue&type=script&lang=ts"
export * from "./AuthBanner.vue?vue&type=script&lang=ts"

import "./AuthBanner.vue?vue&type=style&index=0&id=2faab3d8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/website-app/website-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2faab3d8"]])

export default __exports__